export function useWelcomeFeature({ autoLoad } = { autoLoad: true }) {
  const { welcomeOfferEnabled } = useRuntimeConfig().public;
  const store = shallowRef<ReturnType<(typeof import('~/store/welcome'))['useWelcomeStore']> | null>(null);

  async function load(): Promise<typeof store.value> {
    if (!welcomeOfferEnabled) return null;
    if (store.value) return store.value;

    const { useWelcomeStore } = await import('~/store/welcome');

    if (typeof useWelcomeStore === 'function') {
      store.value = useWelcomeStore();
    }

    return store.value;
  }

  if (autoLoad) {
    load();
  }

  return { store, load };
}
